module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAOklEQVRIx2O8JyDBQBvAODSN/rJ2A62M/v///xA0evnmS7QymkGldtToUaMHJvENzdxIw+JptCpABQA76x7teG8pjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/th.png
// module id = 938
// module chunks = 0